export default {
	benefits: {
		title: "Benefits",
		wide_audience: {
			title: "Reach a Wide Audience",
			description: "We are building the largest online consumer panels in Africa"
		},
		fast: {
			title: "Get Results Fast",
			description: "Start getting results in hours instead of having to wait weeks"
		},
		money: {
			title: "Save Money",
			description: "All that for a fraction of the cost of traditional methods"
		}
	},
	products: {
		title: "Products",
		survey: {
			title: "Send a survey",
			description: "Create professional surveys in minutes and reach a large audience at the push of a button",
		},
		reactions: {
			title: "Collect people\'s reaction",
			description: "Capture unbiased behavioral data on what the audience likes and dislikes using emotions and artificial intelligence",
		}
	},
	use_cases: {
		title: "Use cases",
		ad_video: {
			title: "Test your video ad",
			description: "Upload your video and we tell you what people like and dislike",
		},
		billboard: {
			title: 'Test your billboard',
			description: 'Upload your different campaigns and we tell you which ones resonate with your audience'
		},
		market_research: {
			title: 'Market research',
			description: 'With real time surveys, hear directly from your target customers for market research: pricing, product development, etc.',
		}
	},
	dashboard: "Dashboard",
	admin: "Admin",
	sign_in: "Sign in",
	sign_out: "Sign out",
	title: "Before launching your concepts, Test them!",
	sub_title: "Reach people -- anywhere, anytime -- to gather their feedback",

	learn_more: "LEARN MORE",
	get_started: "Get Started",
	our_platform: {
		title: "Our platform",
		description: "allows you to reach people to gather their feedback, understand what they think and confirm whether it applies to your wider audience."
	},
	our_offer: {
		title: "We offer",
		description: "a combination of products, allowing you to test your concepts before launching and optimize your ROI on your spending"
	},
	use_case_example: "Example #{0}",
	contact_us: {
		title: "Want to learn more?",
		name: "Enter your name",
		email: "Enter your email address",
		phone: "(or) your phone number",
		message: "Leave a message",
		submit: "Contact us!",
		close: "Close"
	},
	marketIntelligence: {
		title: 'A Market intelligence platform',
		description: 'Manage your data collection campaigns using your own field agents! You don\'t have such network? Leverage our network of trained field agents and panels'
	},
	sign_in_success: 'Sign in successful',
	sign_in_error: 'Sign in failed, please check your credentials and retry',
	email_address: 'Email address',
	password: 'Password',
	submit: 'Submit',
	field_mandatory: 'This field is mandatory',
	email_mandatory: 'Email address is mandatory',
	email_format: 'Please enter a valid email address',
};